const CheckmarkIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16 15"
  >
    <path
      className={className}
      d="M13.283.06c-.497.053-.946.362-1.243.856l-5.835 9.352L3.446 6.7c-.392-.51-.86-.76-1.415-.76-.886 0-1.59.723-1.59 1.618 0 .413.157.808.439 1.164l3.85 4.776c.462.564.957.834 1.575.834.626 0 1.15-.306 1.531-.868l6.82-10.726c.257-.396.409-.777.409-1.165 0-.894-.749-1.52-1.631-1.52l-.15.008z"
    />
  </svg>
);

export default CheckmarkIcon;
